import { compose, withState, withHandlers } from 'recompose';
import BenefitSection from './BenefitSection';
import { sendEvent } from '../../core/services/tracking';

const configureState = withState('open', 'setOpen', false);

const configureHandlers = withHandlers({
  handleClick: props => () => {
    props.setOpen(!props.open);
    sendEvent({
      event_type: 'click',
      object_detail: 'view_benefit',
      data: {
        title: props.benefit.title,
      },
    });
  },
});

export default compose(
  configureState,
  configureHandlers,
)(BenefitSection);
